// 9fbef606107a605d69c0edbcd8029e5d 
const RESEND_ORDER_CONSTANTS = {
  RESEND_ORDER_EMAIL: 'RESEND_ORDER_EMAIL',
  VALIDATE_EMAIL: 'VALIDATE_EMAIL',
  RESEND_ORDER_CONFIRMATION_MODAL: 'RESEND_ORDER_CONFIRMATION_MODAL',
};

export default RESEND_ORDER_CONSTANTS;
